function getImageURL(element, title) {
    let productJson = $(element).find('.custom-product-script').html();
    let productData = JSON.parse(productJson);
    let imageUrl = productData.formatted[title];
    return imageUrl;
}

jQuery(document).ready(function() {
    
    let selectedSessionValue = sessionStorage.getItem('selectedOption');
    if (selectedSessionValue !== null) {

        let currentCollection = $('#bestseller-collection').val();
        $('.custom-option-selector').val(selectedSessionValue);
        $(`.${currentCollection} .slide-item`).each(function() {
            // Set the image src attribute based on the selected option
            $(this).find('a:first-child img').attr('src', getImageURL(this, selectedSessionValue));
        });
    }
    if ($(window).width() >= 1024) {
      $('.cd-tab-1-ifr').show();
        jQuery('.custom-tabs .tab-heading').click(function() {
            $('.cd-tab-1-ifr').hide();
            jQuery('.custom-tabs .tab-headings').removeClass('active');
            jQuery(this).closest('.tab-headings').addClass('active');
            let target = jQuery(this).attr('data-tab-heading');
            jQuery('.tab-contents').removeClass('active');
            jQuery('.tab-contents[data-tab-content="' + target + '"]').addClass('active');

            var datamedia = $(this).attr('data-media');
            console.log(datamedia);
            var htmlContent = $('.bviframe #'+datamedia).html();
            // var htmlContent = $('#ct-iframe-2').html();
            console.log(htmlContent);
            $('.'+datamedia).html(htmlContent);

        });
    }
    /*
    // if ($(window).width() <= 1023) {
    //     jQuery('.custom-tabs .tab-content-wrapper .tab-contents > .inner-heading').click(function() {
    //         jQuery(this).siblings('.tab-content-inner').toggleClass('active-inner');
    //           var datamedia = $(this).attr('data-media');
    //           var htmlContent = $('.bviframe #'+datamedia).html();
    //           // var htmlContent = $('#ct-iframe-2').html();
    //           $('.'+datamedia).html(htmlContent);
    //           $(`.${datamedia} + .desktop-hide iframe`).css('width', '100%').attr('width', '100%');
    //     });
    // }
   // if ($(window).width() <= 1023) {
   //      jQuery('.custom-tabs .tab-content-wrapper .tab-contents > .inner-heading').click(function () {
   //          const contentInner = jQuery(this).siblings('.tab-content-inner');
            
   //          // Check if the current tab content is already active
   //          if (contentInner.hasClass('active-inner')) {
   //              // If active, remove the active class to close it
   //              contentInner.removeClass('active-inner');
   //          } else {
   //              // If not active, remove active class from all and activate the clicked tab
   //              jQuery('.custom-tabs .tab-content-wrapper .tab-content-inner').removeClass('active-inner');
   //              contentInner.addClass('active-inner');
   //          }
   //      });
   //  }
    */
    jQuery(document).on('change', '#bestseller-collection', function() {
        var currentCollection = $(this).val();
        let optionValue = $('.custom-option-selector').val();

        // var currentCollectionTitle = $(this).find('option:selected').text();
        var currentCollectionurl = $(this).find('option:selected').attr('data-handle');
        jQuery('.bvanchor.custom-btn').attr('href', currentCollectionurl);
        jQuery('.slider-div').removeClass('active');
        jQuery('.slider-div').hide();
        jQuery('.' + currentCollection).addClass('active');
        jQuery('.' + currentCollection).show();
        $(`.${currentCollection} .slide-item`).each(function() {
            // Set the image src attribute based on the selected option
            $(this).find('a img').attr('src', getImageURL(this, optionValue));
          
        });

        $('.slider-div').slick('unslick');
        // $('.slider-div').slick();

        jQuery(".slider-div").slick({
            arrow: true,
            dots: true,
            vertical: false,
            centerMode: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [{
                    breakpoint: 999,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        rows: 2
                    }
                }
            ]
        });

    });

});

jQuery(document).on('change', '.custom-option-selector', function() {
    let optionValue = $(this).val();
    sessionStorage.setItem("selectedOption", optionValue);
    let currentCollection = $('#bestseller-collection').val();
    $(`.${currentCollection} .slide-item`).each(function() {
        // Set the image src attribute based on the selected option
        $(this).find('a:first-child img').attr('src', getImageURL(this, optionValue));
    });
});

// you may also like slider
jQuery(".slider-div").slick({
    arrow: true,
    dots: true,
    vertical: false,
    centerMode: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [{
            breakpoint: 999,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                rows: 2
            }
        }
    ]
});

jQuery(".homepage-collection-grid .grid").slick({
    arrow: true,
    dots: true,
    vertical: false,
    centerMode: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [{
            breakpoint: 1025,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 769,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1
            }
        }
    ]
});

//stickyheader
const headers = document.querySelectorAll(".site-header");

window.addEventListener("scroll", () => {
    headers.forEach(header => {
        if (!header) return;
        if (window.scrollY > 0) {
            header.classList.add("sticky-header");
        } else {
            header.classList.remove("sticky-header");
        }
    });
});

window.onload = function() {
    const headerHeight = document.querySelector('.site-header ').clientHeight;
    const contentDiv = document.getElementById('icon-header-sec');

    contentDiv.style.transform = 'translateY(${headerHeight}px)';

};

function slickadd() {
    var $sliderFor = jQuery('.product_slider-for');
    var $sliderNav = jQuery('.product_slider-nav');
    if (!$sliderFor.length || !$sliderNav.length) return;
    if (typeof jQuery.fn.slick !== 'function') return;
    if ($sliderFor.children().length === 0 || $sliderNav.children().length === 0) return;
    try {
        if ($sliderFor.hasClass('slick-initialized')) $sliderFor.slick('unslick');
        if ($sliderNav.hasClass('slick-initialized')) $sliderNav.slick('unslick');
        $sliderFor.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
            dots: false,
            asNavFor: '.product_slider-nav'
        });
        $sliderNav.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '.product_slider-for',
            dots: false,
            arrows: false,
            centerMode: false,
            focusOnSelect: true,
            infinite: false,
            responsive: [{
                    breakpoint: 1023,
                    settings: {
                        arrows: false,
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        infinite: false
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        arrows: false,
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        infinite: false
                    }
                }
            ]
        });
    } catch (e) {
        console.warn('Slick slider init skipped:', e && e.message ? e.message : e);
    }
}

/*
    $(".product-form__variants").change(function(){
    $('.product_slider-for').css('display','block');
    $('.product_slider-nav').css('display','block');
    }); 
*/
document.addEventListener('DOMContentLoaded', function() {
    //startfaq
    slickadd();
    const activeDiv = document.querySelector('.active');

    if (activeDiv) {
        const nextDiv = activeDiv.nextElementSibling;
        if (nextDiv) {
            nextDiv.style.maxHeight = nextDiv.scrollHeight + 'px';
        } else {
            console.log('Next div not found');
        }
    } else {
        console.log('Active div not found');
    }
    const faqQuestions = document.querySelectorAll('.faq-question');
    faqQuestions.forEach(function(question) {
        question.addEventListener('click', function() {
            const answer = this.nextElementSibling;
            const icon = this.querySelector('.faq-icon');
            if (this.classList.contains('active')) {
                // If the question is active, close the answer, change icon, and remove 'active' class
                this.classList.remove('active');
                icon.textContent = '+';
                answer.style.maxHeight = null;
            } else {

                document.querySelectorAll('.faq-question.active').forEach(function(activeQuestion) {
                    activeQuestion.classList.remove('active');
                    const activeAnswer = activeQuestion.nextElementSibling;
                    activeAnswer.style.maxHeight = null;
                    const activeIcon = activeQuestion.querySelector('.faq-icon');
                    activeIcon.textContent = '+';
                });
                this.classList.toggle('active');
                if (this.classList.contains('active')) {
                    icon.textContent = '-';
                } else {
                    icon.textContent = '+';
                }
                if (answer.style.maxHeight) {
                    answer.style.maxHeight = null;
                } else {
                    answer.style.maxHeight = answer.scrollHeight + 'px';
                }
            }
        });
    });
    //endfaq

    //product description toggle
    const desctitle = document.querySelectorAll('.acc__title');
    desctitle.forEach(function(question) {
        question.addEventListener('click', function() {
            const answer = this.nextElementSibling;
            const icon = this.querySelector('.faq-icon');
            if (this.classList.contains('active')) {
                // If the question is active, close the answer, change icon, and remove 'active' class
                this.classList.remove('active');

                answer.style.display = "none";
            } else {

                document.querySelectorAll('.acc__title.active').forEach(function(activeQuestion) {
                    activeQuestion.classList.remove('active');
                    const activeAnswer = activeQuestion.nextElementSibling;
                    activeAnswer.style.display = "none";
                    const activeIcon = activeQuestion.querySelector('.faq-icon');

                });
                this.classList.toggle('active');

                if (answer.style.maxHeight) {
                    answer.style.display = "none";
                } else {
                    answer.style.display = "block";
                }

            }
        });
    });

    //qty button
    $('.js-qty__adjust').off().on('click', function() {

        var el = $(this),
            id = el.data('id'),
            qtySelector = el.siblings('.js-qty__num'),
            qty = parseInt(qtySelector.val().replace(/\D/g, '')),
            submit = qtySelector.data('submit');

        // Make sure we have a valid integer
        if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
            // We have a number!
        } else {
            // Not a number. Default to 1.
            qty = 1;
        }

        // Add or subtract from the current quantity
        if (el.hasClass('js-qty__adjust--plus')) {
            qty = qty + 1;
        } else {
            qty = qty - 1;
            if (qty <= 1) qty = 1;
        }

        // Update the input's number
        qtySelector.val(qty).trigger('change');
        if (submit) {
            qtySelector.parents('form').submit();
        }
    });

    //videopopup
    const playButton = document.getElementById('popup_js_video');
    const closeButton = document.querySelector(".close-button");
    const modal = document.querySelector(".video-modal");
    const videoContainer = document.querySelector(".video-player");
    const overlay = document.querySelector(".overlay");
    if (playButton) {
        playButton.addEventListener("click", function() {
            const videoId = playButton.getAttribute("data-video-id");


            // Add class to body
            document.body.classList.add("popup-active");

            videoContainer.innerHTML = `<iframe width="700" height="600" src="https://www.youtube.com/embed/${videoId}?autoplay=1" frameborder="0" allowfullscreen></iframe>`;

            modal.style.display = "block";
            // Display overlay
            overlay.style.display = "block";
        });
    }
    if (closeButton) {
        closeButton.addEventListener("click", function() {
            modal.style.display = "none";
            videoContainer.innerHTML = ``;
            document.body.classList.remove("popup-active");
            overlay.style.display = "none";
        });
    }
    if (overlay) {
        overlay.addEventListener("click", function() {
            modal.style.display = "none";
            videoContainer.innerHTML = ``;
            document.body.classList.remove("popup-active");
            overlay.style.display = "none";
        });
    }

    //change price when change variant
    // This functionality has been moved to product-form.liquid script
    /*
    $('.product-form__variants').on('click', function() {
        console.log('variant change via cilck');
        var splashArray = new Array();
        var allArray = new Array();
        $('.product_slider-for, .product_slider-nav').slick('unslick');
        $('.product_slider-for,.product_slider-nav').html('');

        let selectedVariant = $('.variantid').val();
        console.log(selectedVariant);
        
        // let selectedVariant = $(this).val();

        var url = window.location.href.split('?')[0]; // Get the current URL without query params
        window.history.replaceState(null, null, url + '?variant=' + selectedVariant); // Update URL

        $('.product-form__variants option:nth-child(1)').removeAttr('selected');
        var dataprice = $('.variantid').attr('data-price');
        var dataid = $('.variantid').val();
        var data_saleprice = $('.variantid').attr('data-sale-price');
        //console.log(dataprice,data_saleprice);
        // console.log(dataid);
        
        $('.hiddenimages img').each(function(i, val) {
            var variantid = $(this).attr('data-variant');
            allArray.push($(this).attr("src"));
            if (variantid == dataid) {
                splashArray.push($(this).attr("src"));
            }
        });

        var elements = $();
        $.each(splashArray, function(i, v) {
            elements = elements.add('<div class="item-product-img"><img data-product-image  src="' + v + '"  alt="{{ media.variants.alt }}" /></div>');
        });

        var allimages = $();
        $.each(allArray, function(i, v) {
            allimages = allimages.add('<div class="item-product-img"><img data-product-image  src="' + v + '"  alt="{{ media.variants.alt }}" /></div>');
        });

        if (splashArray.length > 1) {
            $('.product_slider-for ,.product_slider-nav').append(elements);
            slickadd();
        } else {
            if (splashArray.length == 0) {
                $('.product_slider-for ,.product_slider-nav').append(allimages);
                slickadd();
            } else {
                $('.product_slider-for').append(elements);
            }

        }

        $('.product__price .regularprice span').html(dataprice);
        if (data_saleprice != '') {
            $('.product__price').addClass('on-sale');
            $('.compareprice span').html(data_saleprice);
            $('.compare-at').show();
            $('.save-wrap').show();
        } else {
            $('.product__price').removeClass('on-sale');
            $('.compare-at').hide();
            $('.save-wrap').hide();
        }
    });
    */
});

//faq page
let userAgent = window.navigator.userAgent;
let os = "Unknown OS";
if (userAgent.indexOf("Win") != -1) os = "Windows";
if (userAgent.indexOf("Mac") != -1) os = "MacOS";
if (userAgent.indexOf("X11") != -1) os = "UNIX";
if (userAgent.indexOf("Linux") != -1) os = "Linux";

function detectOS() {
    let userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'],
        os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'Windows';
    } else if (/Android/.test(userAgent)) {
        os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
        os = 'Linux';
    }

    return os;
}

let userOS = detectOS();
if (userOS == 'Linux') {
    $('.accordion-toggle').click(function() {
        $(this).next('.accordion-content').slideToggle();
        $('.accordion-content').not($(this).next()).slideUp();
        $(this).find('.icon').toggleClass('icon-plus icon-minus');
    });
}
